import StickyAdvancedFilters from 'sticky_advanced_filters/scripts/sticky_advanced_filters'

$(function () {
  StickyAdvancedFilters.init()
})
